module.exports = __webpack_public_path__ + "media/images/icon/i-branding-07e843c76d8ffdecabdc2b09651a3521.svg";